import React from 'react';
import { XIcon } from 'lucide-react';
interface ImpressumProps {
  onClose: () => void;
}
export const Impressum = ({
  onClose
}: ImpressumProps) => {
  return <div className="fixed inset-0 bg-white z-50 overflow-y-auto p-6" data-id="element-20">
      <div className="max-w-2xl mx-auto" data-id="element-21">
        <div className="flex justify-between items-center mb-6" data-id="element-22">
          <h1 className="text-2xl font-bold text-[#e76405]" data-id="element-23">Impressum</h1>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-24">
            <XIcon size={24} data-id="element-25" />
          </button>
        </div>
        <div className="space-y-6" data-id="element-26">
          <section data-id="element-27">
            <h2 className="text-xl font-semibold mb-2" data-id="element-28">
              Angaben gemäß § 5 TMG
            </h2>
            <p data-id="element-29">INTIGOO! GmbH</p>
            <p data-id="element-30">Werner-von-Siemens-Straße 33</p>
            <p data-id="element-31">49124 Georgsmarienhütte</p>
            <p className="mt-2" data-id="element-32">Handelsregister: HRB 217224</p>
            <p data-id="element-33">Registergericht: Amtsgericht Osnabrück</p>
            <p className="mt-2" data-id="element-34">Vertreten durch:</p>
            <p data-id="element-35">Fabian Kleine Huxel</p>
            <p data-id="element-36">Felix Höfelmeyer</p>
          </section>
          <section data-id="element-37">
            <h2 className="text-xl font-semibold mb-2" data-id="element-38">Kontakt</h2>
            <p data-id="element-39">Telefon: +49 5401 1689580</p>
            <p data-id="element-40">E‑Mail: info@intigoo.de</p>
          </section>
          <section data-id="element-41">
            <h2 className="text-xl font-semibold mb-2" data-id="element-42">Umsatzsteuer-ID</h2>
            <p data-id="element-43">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
            </p>
            <p data-id="element-44">DE 349819653</p>
          </section>
          <section data-id="element-45">
            <h2 className="text-xl font-semibold mb-2" data-id="element-46">EU-Streitschlichtung</h2>
            <p data-id="element-47">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer" data-id="element-48">
                https://ec.europa.eu/consumers/odr/
              </a>
              .
            </p>
            <p data-id="element-49">Unsere E‑Mail-Adresse finden Sie oben im Impressum.</p>
          </section>
          <section data-id="element-50">
            <h2 className="text-xl font-semibold mb-2" data-id="element-51">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p data-id="element-52">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>
        </div>
        <div className="mt-8 text-center" data-id="element-53">
          <button onClick={onClose} className="bg-[#e76405] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#d55a00] transition-colors" data-id="element-54">
            Zurück
          </button>
        </div>
      </div>
    </div>;
};